export const PDF_DATA_NAME = 'data';
export const PDF_RESULTS_NAME = 'results';
export const PDF_MERGED_NAME = '_merged';
